module.exports = __webpack_public_path__ + "img/media_20.3d0786fe.jpg";